import type { ReactNode } from 'react';

type LabelWidth = 'sm' | 'md' | 'lg';

const LABEL_WIDTH_CLASS: Record<LabelWidth, string> = {
  sm: 'sm:w-20', // 80px
  md: 'sm:w-32', // 128px
  lg: 'sm:w-40', // 160px
};

export interface InfoRowProps {
  label: string;
  value: ReactNode;
  labelWidth?: LabelWidth;
}

export function InfoRow({ label, value, labelWidth = 'md' }: InfoRowProps) {
  const isEmpty = value === null || value === undefined || value === '';
  const displayValue = isEmpty ? '-' : value;
  const widthClass = LABEL_WIDTH_CLASS[labelWidth];

  return (
    <div className="flex flex-col sm:flex-row sm:items-start py-1.5 gap-1 sm:gap-3">
      <div
        className={`${widthClass} flex-shrink-0 text-xs font-medium text-gray-500 pt-0.5`}
      >
        {label}
      </div>
      <div className="flex-1 text-sm text-gray-900">{displayValue}</div>
    </div>
  );
}
